import * as React from 'react';
import { get } from 'lodash';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import { compose, withHandlers, withProps } from 'recompose';
import { reduxForm } from 'redux-form';
import { saveAs } from 'file-saver';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { Card } from 'material-ui';
import { moveTickets, getReportMove } from '@modules/tickets/_ticketsActions';
import { TicketsMoveFormBasic } from '@modules/tickets/TicketsMoveFormBasic';

export const enhance = compose<any, any>(
  withHandlers({
    onSubmit: ({ closeItem, checkedItems, refresh, handleLoader, moveTemplate }) => async data => {
      handleLoader(true);
      const result = await moveTickets({ checkedItems, ...data });
      if (result) {
        const report = await getReportMove(moveTemplate, result);

        if (report) {
          const blob = await report.blob();

          saveAs(blob, get(moveTemplate, 'fileName', 'report.xslx'));
        }
        if (refresh) {
          refresh();
        }
        await closeItem();
      }
      handleLoader(false);
    }
  }),
  withProps(({ checkedItems }) => ({
    initialValues: {
      checkedItems
    }
  })),
  breadcrumbs(() => [{ label: 'Přesun' }]),
  reduxForm({ form: 'ticekts-move' })
);

const View: React.SFC<any> = ({ handleSubmit, closeItem }) => (
  <div>
    <form className="layout" onSubmit={handleSubmit}>
      <Card>
        <TicketsMoveFormBasic />
        <Button type="submit" label="Přesunout" primary={true} style={{ margin: '16px 0 16px 16px' }} />
        <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={closeItem} />
      </Card>
    </form>
  </div>
);
export const TicketsMoveForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/tickets/TicketsMoveForm.tsx